import React from 'react';
import SignUp from '../../components/organisms/Auth/SignUp';
import { GlobalState } from '../../components/context/Silverstripe';
import SiteLayout from '../../components/layouts/SiteLayout';
import SEO from '../../components/SEO';

const title = 'Sign up';

const SignUpAuthPage = ({ globalData }: { globalData: GlobalState }) => (
  <SiteLayout showMenu={false} appState={{ global: { ...globalData } }}>
    <SEO title={title} />
    <SignUp isModal={false} />
  </SiteLayout>
);

export default SignUpAuthPage;
